var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.306,
    y1: -1.754,
    x2: -1.816,
    y2: 1.771,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f28dd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.003,
    y1: 0.501,
    x2: 1.003,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment_Links",
    "data-name": "Payment Links",
    transform: "translate(-832 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6100",
    "data-name": "Rectangle 6100",
    width: 24,
    height: 24,
    transform: "translate(832 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Payment_Link",
    "data-name": "Payment Link",
    transform: "translate(834.028 57.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3252",
    "data-name": "Group 3252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M8.3,12.971h0a2.656,2.656,0,0,1-3.6-1.029L.836,4.735A2.675,2.675,0,0,1,1.78,1.046h0a2.656,2.656,0,0,1,3.6,1.029L9.329,9.368A2.7,2.7,0,0,1,8.3,12.971Z",
    transform: "translate(-0.452 -0.722)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M17.309,12.926h0a2.656,2.656,0,0,1-3.6-1.029l-3.26-5.748a2.656,2.656,0,0,1,1.029-3.6h0a2.656,2.656,0,0,1,3.6,1.029l3.26,5.748A2.678,2.678,0,0,1,17.309,12.926Z",
    transform: "translate(-1.826 -0.935)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M13.076,1.772A2.766,2.766,0,0,0,9.645,3.23L7.672,7.176,7.5,7.519l2.4,5.061c.257-.086,3.946-6.691,4.375-7.549A2.356,2.356,0,0,0,13.076,1.772Z",
    transform: "translate(-1.454 -0.846)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M10.032,10.189,7.974,6.5h0C7.116,8.216,5.4,12.762,5.4,12.762A2.656,2.656,0,0,0,9,13.792H9A2.7,2.7,0,0,0,10.032,10.189Z",
    transform: "translate(-1.155 -1.543)",
    fill: "#18253e"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 4.118,
    cy: 4.118,
    r: 4.118,
    transform: "translate(11.108 9.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3254",
    "data-name": "Group 3254",
    transform: "translate(9.218 8.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3253",
    "data-name": "Group 3253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M11.2,15.933A5.345,5.345,0,0,1,16.6,10.7a5.438,5.438,0,0,1,5.319,5.49A5.364,5.364,0,0,1,11.2,15.933Zm9.008-1.373a2.293,2.293,0,0,0-1.716-2.23,3.053,3.053,0,0,0-3.174,1.63c0,.086,0,.343.086.343a.383.383,0,0,0,.429,0,8.088,8.088,0,0,0,.858-.858,1.633,1.633,0,0,1,2.316-.086,1.563,1.563,0,0,1-.086,2.316l-.858.858a.39.39,0,0,0,0,.429c0,.086.343.086.343.086C19.349,16.362,20.207,15.761,20.207,14.56Zm-7.549,3.174a2.293,2.293,0,0,0,1.716,2.23,3.053,3.053,0,0,0,3.174-1.63c0-.086,0-.343-.086-.343a.383.383,0,0,0-.429,0,8.088,8.088,0,0,0-.858.858,1.74,1.74,0,0,1-2.4.086,1.563,1.563,0,0,1,.086-2.316l.858-.858a.39.39,0,0,0,0-.429c0-.086-.343-.086-.343-.086C13.6,15.847,12.658,16.533,12.658,17.734Zm2.4,0c.086,0,.172,0,.172-.086l2.917-2.917c.086-.086,0-.343-.086-.343a.39.39,0,0,0-.429,0c-.944.944-1.887,1.8-2.745,2.745a.643.643,0,0,0-.086.429C14.888,17.648,14.974,17.734,15.06,17.734Z",
    transform: "translate(-11.197 -10.697)",
    fill: "#33eeb1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLink);
export default __webpack_public_path__ + "static/media/payment_link.3140068107d700900db4ddfcfd86e1c1.svg";
export { ForwardRef as ReactComponent };